export default __webpack_public_path__ + "static/media/picture_scroll3.13425fb5.jpg";